import { Link } from "react-router-dom";
import { ChevronLeft, Coins, Gem, Search } from "lucide-react";
import { TopBarPortal } from "@/components/layout/TopBarSlot";
import { useMe } from "@/hooks/queries";
import { compactNumber, useStudio } from "@/lib/studio";
import { formatNumber } from "@/lib/format";

export function StudioHeader({ title, back = false }) {
  const { data: me } = useMe();
  const { openSearch } = useStudio();
  const balance = me?.credits?.balance;
  return (
    <TopBarPortal>
      <div className="flex w-full min-w-0 items-center gap-1.5 sm:gap-2" data-testid="studio-header">
        {back && (
          <Link to="/create" aria-label="Back to Explore" data-testid="studio-back-button"
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-zinc-400 transition-colors hover:bg-white/[0.05] hover:text-white">
            <ChevronLeft className="h-5 w-5" strokeWidth={1.7} />
          </Link>
        )}
        <h1 className="min-w-0 flex-1 truncate text-center text-[15px] font-semibold tracking-tight text-white lg:flex-none lg:text-left" data-testid="explore-header-title">
          {title}
        </h1>
        <button type="button" onClick={openSearch} data-testid="studio-search-trigger-desktop"
          className="mx-auto hidden h-9 w-full max-w-sm items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.04] px-4 text-sm text-zinc-500 transition-colors hover:border-white/20 hover:text-zinc-300 lg:flex">
          <Search className="h-4 w-4" />
          Search presets, tools, creations
          <kbd className="ml-auto rounded-md bg-white/10 px-1.5 py-0.5 font-mono text-[10px] text-zinc-400">/</kbd>
        </button>
        <Link to="/plan" title={balance != null ? `${formatNumber(balance)} credits` : "Credits"} data-testid="explore-credits-pill"
          className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full border border-white/10 bg-ink-850 px-2.5 text-xs font-medium tabular-nums text-zinc-200 transition-colors hover:border-white/25">
          <Coins className="h-3.5 w-3.5 text-amber-300" />
          {balance != null ? compactNumber(balance) : "—"}
          <span className="sr-only">credits</span>
        </Link>
        <Link to="/plan" aria-label="Upgrade" data-testid="explore-upgrade-button"
          className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full bg-white px-2.5 text-xs font-semibold text-ink-950 transition-transform hover:bg-zinc-100 active:scale-95 min-[400px]:px-3">
          <Gem className="h-3.5 w-3.5" />
          <span className="hidden min-[400px]:inline">Upgrade</span>
        </Link>
      </div>
    </TopBarPortal>
  );
}
